import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useAuth } from '../Context/AuthContext'
import { auth } from '../firebaseConfig'
function ProtectedLoginRoute({ component: Component, ...rest }) {
    const { loggedIn } = useAuth();
    return (
        <Route {...rest} render={(props) => {
            return (!auth.currentUser || !loggedIn) ? <Component /> : <Redirect to="/" />
        }} />
    )
}

export default ProtectedLoginRoute
